import { useQuery } from '@tanstack/react-query';
import { speakersApi } from '../api/speakers';
import type { V1Speaker } from '../types/speaker.types';

/**
 * React Query hook for fetching individual speaker details
 * 
 * @param speakerId - The ID of the speaker to fetch
 * @param options - Optional query options
 * @returns Query result with speaker data, loading state, and error handling
 */
export const useSpeaker = (
  speakerId: string | undefined,
  options?: {
    enabled?: boolean;
    staleTime?: number;
  }
) => {
  return useQuery<V1Speaker>({
    queryKey: ['speaker', speakerId],
    queryFn: () => speakersApi.getSpeaker(speakerId!),
    enabled: !!speakerId && (options?.enabled !== false),
    staleTime: options?.staleTime || 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on 404 (speaker not found) or 403 (access denied)
      if (error?.status === 404 || error?.status === 403) {
        return false;
      }
      return failureCount < 3;
    }
  });
};